
  import { defineComponent, ref, reactive } from "vue"
  import { useRouter } from "vue-router"
  import { useStore } from "vuex"
  import "./scss/CreateFolder.scss"

  export default defineComponent({
    name: "CreateFolder",
    inject: ["Ti18N"],
    setup() {
      const store = useStore()
      const router = useRouter()
      const titleFolder: any = ref(null)
      const isInput = reactive({ value: false })

      const create = async () => {
        await store.dispatch("createFolder", titleFolder.value.value)
        router.push({ name: "FolderPage", params: { id: store.getters.folderAfterCreate } })
      }
      const editInput = (isTrue: boolean) => (isInput.value = isTrue)

      return { titleFolder, create, isInput, editInput }
    },
  })
